import type { NavigateProps } from 'react-router';

import { useCallback } from 'react';
import { useNavigate } from '@ricoh/ria.client.core/hooks/app/router';

import type { ErrorLinkHook } from './error.type';

/**
 * Use ErrorLinkHook.
 *
 * @returns {ErrorLinkHook} ErrorLinkHook hook.
 */
export function useErrorLink(): ErrorLinkHook {
  const navigate = useNavigate();

  return useCallback<ErrorLinkHook>(
    (error) => {
      let link: string;
      switch (error.status) {
        case 503: {
          link = '/error/service-unavailable';
          break;
        }

        case 401: {
          link = '/error/unauthorized';
          break;
        }

        case 403: {
          link = '/error/access-denied';
          break;
        }

        case 404: {
          link = '/error/not-found';
          break;
        }

        case 500:
        default: {
          link = '/error';
          break;
        }
      }

      const props: NavigateProps = {
        to: link,
        replace: true,
        state: error,
      };

      return {
        props,
        navigate: () => {
          const { to, ...options } = props;
          navigate(to, options);
        },
      };
    },
    [navigate],
  );
}
